import styles from './Choice.module.css';

/**
 * Selection controls for the forecast wizard.
 *
 * ChoiceGrid + ChoiceCard: the emoji tile grid (step 1, "pick a sport").
 * ChoiceList + ChoiceRow:  the full-width rows (dates, leagues, matches).
 *
 * Both are plain buttons, so keyboard and screen-reader users get them for free.
 */

export function ChoiceGrid({ className = '', children }) {
  return <div className={`${styles.grid} ${className}`}>{children}</div>;
}

export function ChoiceCard({ emoji, label, selected = false, onClick, ...rest }) {
  return (
    <button
      type="button"
      className={`${styles.choice} ${selected ? styles.sel : ''}`}
      aria-pressed={selected}
      onClick={onClick}
      {...rest}
    >
      {emoji && (
        <span className={styles.em} aria-hidden="true">
          {emoji}
        </span>
      )}
      <span className={styles.choiceLabel}>{label}</span>
    </button>
  );
}

export function ChoiceList({ className = '', children }) {
  return <div className={`${styles.list} ${className}`}>{children}</div>;
}

/** One selectable row: a main label on the left, a quiet detail on the right. */
export function ChoiceRow({ label, detail, selected = false, onClick, ...rest }) {
  return (
    <button
      type="button"
      className={`${styles.row} ${selected ? styles.sel : ''}`}
      aria-pressed={selected}
      onClick={onClick}
      {...rest}
    >
      <span className={styles.rowLabel}>{label}</span>
      {detail && <span className={styles.rowDetail}>{detail}</span>}
    </button>
  );
}
